import liveResponse from "./live-response.jsx"
import responses from "./responses.jsx"

export default {
    liveResponse,
    responses
}
